import { gql } from '@apollo/client'; 

export const BUSINESS_BOOKING_TYPE_FIELDS = `
      id
      title
      start
      end
      recurringInterval
      recurring
      location
      status
      meetingLocationTypeId
      desc
      color
      link
      length
      maxInvitees
      createdBy
      createdByAgentId
      price
      isPaymentRequired
      customQuestions:inviteeQuestions{
      id
      title
      type
      required,
      bookingTypeId
      }
      showRemaining
      bookingSize
      increments
      bookingPerDay
      isVisibleToStaff
      isPublic
      displayOnBookingPage
      phoneNumber
      canInviteeCall 
      bookingApproval
      image
      bookingTypeCategoryId
      assignedStaffs {
        bookingTypeStaffTblId
        name 
        status
        groupId  
        staffId
        permissionId
        hostNotifyEnabled
        hostReminderMinutes
        url
        business {
      name
      }
      }
      groupId
`;

export const GET_BOOKING_TYPES = gql`
  query GetBookingTypes($staffId: Int!) {
    getBookingTypes(staffId: $staffId) {
      id
      title
      start
      end
      recurringInterval
      recurring
      location
      status
      meetingLocationTypeId
      desc
      color
      link
      length
      price
      maxInvitees
      showRemaining
      bookingSize 
      increments
      bookingPerDay
      isVisibleToStaff
      isPublic
      displayOnBookingPage
      phoneNumber
      canInviteeCall
      image
      bookingTypeCategoryId
      bookingApproval
      createdBy
      createdByAgentId
      assignedStaffs {
      bookingTypeStaffTblId
      name 
      status
      groupId  
      staffId
      permissionId
      hostNotifyEnabled
      hostReminderMinutes
      url
      business {
      name
      }
      }
    }
  }
`; 
export const ALL_BOOKING_TYPES = gql`
  query GetAllBookingTypes {
    getAllBookingTypes {
      id
      title
      start
      end
      recurringInterval
      recurring
      location
      status
      meetingLocationTypeId
      desc
      color
      link
      length
      maxInvitees
      price
      isPaymentRequired
      customQuestions:inviteeQuestions{
      id
      title
      type
      required,
      bookingTypeId
      }
      showRemaining
      bookingSize
      increments
      bookingPerDay
      isVisibleToStaff
      isPublic
      displayOnBookingPage
      phoneNumber
      canInviteeCall 
      bookingApproval
      image
      bookingTypeCategoryId
      assignedStaffs {
        bookingTypeStaffTblId
        name 
        status
        groupId  
        staffId
        permissionId
        hostNotifyEnabled
        hostReminderMinutes
        url
        business {
      name
      }
      }
      groupId
    }
  }
`; 

export const GET_BUSINESS_BOOKING_TYPES = gql`
  query GetBusinessBookingTypes($businessUrl: String!) {
    getBusinessBookingTypes(businessUrl: $businessUrl) {
      ${BUSINESS_BOOKING_TYPE_FIELDS}
    }
  }
`;


